// ChatWithInput.tsx
// Componente React + Chakra UI v2 que renderiza uma conversa em estilo chat
// Inclui: bolhas de mensagem, avatar, nome (quando aplicável), input com envio
// Enter -> enviar, Shift+Enter -> nova linha, auto-scroll, callback onSendMessage opcional

import { User } from 'UnifiedLogin/types'

import MessageCenterChatManagerProvider from './contexts/MessageCenterChatManager/Provider'
import MessageCenterChatComponent from './Component'
import { MessageCenterRoutes } from './types'

export type MessageCenterChatContentProps = {
  routes: MessageCenterRoutes
  currentUser: User
  height?: string | number
}

export default function MessageCenterChat(props: MessageCenterChatContentProps) {
  return (
    <MessageCenterChatManagerProvider routes={props.routes}>
      <MessageCenterChatComponent {...props} />
    </MessageCenterChatManagerProvider>
  )
}
